import { PartnerType } from "@tm/isomorphic-utils";
import React from "react";
import { ThemeProvider } from "styled-components";
import {
  DeviceContextV2,
  DeviceContextV2Type,
} from "../Contexts/DeviceContext";

export function withDeviceAndThemeProvider(
  comp: JSX.Element,
  device: DeviceContextV2Type,
  theme: {
    pageTheme: PartnerType;
  }
) {
  const renderDevice = device === "tablet" ? "desktop" : device;

  return (
    <DeviceContextV2.Provider value={renderDevice}>
      {React.createElement(ThemeProvider as any, { theme }, comp)}
    </DeviceContextV2.Provider>
  );
}
